import { DocumentStatusId, TimeRangeIDs } from "@documents/models/filter.models";

export const statusFilterOptions = [
  { id: DocumentStatusId.All, label: "All" },
  { id: DocumentStatusId.Read, label: "Read" },
  { id: DocumentStatusId.Unread, label: "Unread" },
  { id: DocumentStatusId.ActionItems, label: "Action Items" },
  { id: DocumentStatusId.UnreadActionItems, label: "Unread Action Items" },
];
// LPC-10285: Admin users now only see Active documents by default (same as Non-Admin)
// Pending documents (P, W, V) will only show when "All dates" is selected (no date filter)
export const documentStatusesAdmin = ["A", "P", "W", "V"];
export const documentStatusesNonAdmin = ["A"];

export const timeRangeOptions: {
  label: string;
  id: TimeRangeIDs;
}[] = [
  { id: TimeRangeIDs.ALL, label: "All dates" },
  { id: TimeRangeIDs.LAST30, label: "Last 30 days" },
  {
    id: TimeRangeIDs.LAST90,
    label: "Last 90 days",
  },
  {
    id: TimeRangeIDs.YEARBEGINNING,
    label: "Since beginning of year",
  },
  {
    id: TimeRangeIDs.EXACTRANGE,
    label: "Exact date range",
  },
];
